import { NgModule } from '@angular/core';
import {
	DropdownComponent,
	DropDownButtonDirective
} from './dropdown.component';
import { CommonModule } from '@angular/common';
import { EdAssistUIOverlayModule } from '../overlay';
import { DropdownService } from './dropdown.service';
import { DROPDOWN_TYPES } from './dropdown-types.enum';
import { DROPDOWN_ORIENTATION } from './dropdown-orientation.enum';

const COMPONENTS = [DropdownComponent, DropDownButtonDirective];

@NgModule({
	exports: COMPONENTS,
	imports: [CommonModule, EdAssistUIOverlayModule],
	declarations: COMPONENTS
})
class EdAssistUIDropdownModule {}

export {
	EdAssistUIDropdownModule,
	DropdownComponent,
	DropdownService,
	DROPDOWN_TYPES,
	DROPDOWN_ORIENTATION
};
